var _a;
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { createSlice } from "@reduxjs/toolkit";
import { isUndefined, } from "@sequentech/ui-core";
var initialState = {};
export var ballotSelectionsSlice = createSlice({
    name: "ballotSelections",
    initialState: initialState,
    reducers: {
        clearBallot: function (state) {
            state = initialState;
            return initialState;
        },
        setBallotSelection: function (state, action) {
            var currentElection = state[action.payload.ballotStyle.election_id];
            if (currentElection) {
                state[action.payload.ballotStyle.election_id] = action.payload.ballotSelection;
            }
            return state;
        },
        resetBallotSelection: function (state, action) {
            var currentElection = state[action.payload.ballotStyle.election_id];
            if (!currentElection || action.payload.force) {
                state[action.payload.ballotStyle.election_id] =
                    action.payload.ballotStyle.ballot_eml.contests.map(function (question) {
                        var _a;
                        var currentContestValue = (_a = state[action.payload.ballotStyle.election_id]) === null || _a === void 0 ? void 0 : _a.find(function (contest) { return contest.contest_id === question.id; });
                        if (currentContestValue &&
                            action.payload.contestId &&
                            action.payload.contestId !== question.id) {
                            return {
                                contest_id: currentContestValue.contest_id,
                                is_explicit_invalid: currentContestValue.is_explicit_invalid,
                                invalid_errors: currentContestValue.invalid_errors,
                                invalid_alerts: currentContestValue.invalid_alerts,
                                choices: currentContestValue.choices,
                            };
                        }
                        return {
                            contest_id: question.id,
                            is_explicit_invalid: false,
                            invalid_errors: [],
                            invalid_alerts: [],
                            choices: question.candidates.map(function (answer) { return ({
                                id: answer.id,
                                selected: -1,
                            }); }),
                        };
                    });
            }
            return state;
        },
        setBallotSelectionInvalidVote: function (state, action) {
            var ballotEmlContest = action.payload.ballotStyle.ballot_eml.contests.find(function (contest) { return contest.id === action.payload.contestId; });
            // check bounds
            if (isUndefined(ballotEmlContest)) {
                return state;
            }
            // find question
            var currentElection = state[action.payload.ballotStyle.election_id];
            var currentQuestion = currentElection === null || currentElection === void 0 ? void 0 : currentElection.find(function (contest) { return contest.contest_id === action.payload.contestId; });
            // update state
            if (!isUndefined(currentQuestion)) {
                currentQuestion.is_explicit_invalid = action.payload.isExplicitInvalid;
            }
            return state;
        },
        setBallotSelectionBlankVote: function (state, action) {
            var ballotEmlContest = action.payload.ballotStyle.ballot_eml.contests.find(function (contest) { return contest.id === action.payload.contestId; });
            // check bounds
            if (isUndefined(ballotEmlContest)) {
                return state;
            }
            // find question
            var currentElection = state[action.payload.ballotStyle.election_id];
            var currentQuestion = currentElection === null || currentElection === void 0 ? void 0 : currentElection.find(function (contest) { return contest.contest_id === action.payload.contestId; });
            // update state
            if (!isUndefined(currentQuestion)) {
                currentQuestion.is_explicit_invalid = false;
                currentQuestion.choices = currentQuestion.choices.map(function (choice) {
                    if (choice.selected > -1) {
                        choice.selected = -1;
                    }
                    return choice;
                });
            }
            return state;
        },
        setBallotSelectionVoteChoice: function (state, action) {
            var ballotEmlContest = action.payload.ballotStyle.ballot_eml.contests.find(function (contest) { return contest.id === action.payload.contestId; });
            // check bounds
            if (isUndefined(ballotEmlContest)) {
                return state;
            }
            var currentElection = state[action.payload.ballotStyle.election_id];
            var currentQuestion = currentElection === null || currentElection === void 0 ? void 0 : currentElection.find(function (contest) { return contest.contest_id === action.payload.contestId; });
            var currentChoiceIndex = currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.choices.findIndex(function (choice) { return action.payload.voteChoice.id === choice.id; });
            var currentChoice = !isUndefined(currentElection) &&
                !isUndefined(currentChoiceIndex) &&
                currentChoiceIndex > -1
                ? currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.choices[currentChoiceIndex]
                : undefined;
            // check election state
            if (!currentElection || isUndefined(currentChoice)) {
                return state;
            }
            // modify
            if (currentQuestion && !isUndefined(currentChoiceIndex)) {
                currentQuestion.choices[currentChoiceIndex] = action.payload.voteChoice;
            }
            return state;
        },
    },
    /*extraReducers: (builder) => {
        builder.addCase(fetchElectionByIdAsync.fulfilled, (state, action) => {
            if (!action.payload) {
                return state
            }
            ballotSelectionsSlice.caseReducers.resetBallotSelection(state, {
                payload: {
                    election: action.payload,
                },
                type: "ballotSelections/resetBallotSelection",
            })
            return state
        })
    },*/
});
export var clearBallot = (_a = ballotSelectionsSlice.actions, _a.clearBallot), setBallotSelection = _a.setBallotSelection, resetBallotSelection = _a.resetBallotSelection, setBallotSelectionInvalidVote = _a.setBallotSelectionInvalidVote, setBallotSelectionBlankVote = _a.setBallotSelectionBlankVote, setBallotSelectionVoteChoice = _a.setBallotSelectionVoteChoice;
export var selectBallotSelectionVoteChoice = function (electionId, contestId, answerIndex) { return function (state) {
    var _a, _b;
    return (_b = (_a = state.ballotSelections[electionId]) === null || _a === void 0 ? void 0 : _a.find(function (contest) { return contest.contest_id === contestId; })) === null || _b === void 0 ? void 0 : _b.choices.find(function (choice) { return answerIndex === choice.id; });
}; };
export var selectBallotSelectionQuestion = function (electionId, contestId) { return function (state) { var _a; return (_a = state.ballotSelections[electionId]) === null || _a === void 0 ? void 0 : _a.find(function (contest) { return contest.contest_id === contestId; }); }; };
export var selectBallotSelectionByElectionId = function (electionId) { return function (state) {
    return state.ballotSelections[electionId];
}; };
export default ballotSelectionsSlice.reducer;
